import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Cancellation fee charged when move is cancelled after starting.
 */
export const schema = z.number().nonnegative().max(1000);

export type CancellationFee = z.infer<typeof schema>;

export const definition = define({
  key: 'cancellation_fee',
  schema,
  label: 'Cancellation Fee',
  description: 'Amount to charge clients at this level for cancelling a move that has already been started.',
  warning: 'This does not apply to dry-run cancellations.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.PRICING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.REGION, LEVELS.ORGANIZATION, LEVELS.CUSTOMER, LEVELS.RATERULEGROUP],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 50,
});
